var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH732(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffd15c;mix-blend-mode:screen;}.cls-2{fill:#fff;opacity:0;}.cls-3{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100,37.99c-51.6,0-78.59,39.26-87.33,54.97-2.23,4.02-2.37,8.88-.36,13.01,7.84,16.11,32.81,56.03,87.69,56.03s79.85-39.92,87.69-56.03c2.01-4.13,1.87-9-.36-13.01-8.74-15.72-35.73-54.97-87.33-54.97Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100,
    cy: 100,
    r: 43.22
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH732);
export default __webpack_public_path__ + "static/media/H73-2.bbea8dba937561cea3993491e4126252.svg";
export { ForwardRef as ReactComponent };